import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import HttpsRedirect from "react-https-redirect";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import { store, persistor } from "./providers/store";
import { Toast } from "components";
import { applyTheme } from "./hooks/useTheme";
import App from "./App";
import "../src/assets/css/tailwind.css";

applyTheme(localStorage.getItem('cpay-client-theme') || 'system');

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<HttpsRedirect>
        <React.StrictMode>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <BrowserRouter>
                        <Toast />
                        <App />
                    </BrowserRouter>
                </PersistGate>
            </Provider>
        </React.StrictMode>
    </HttpsRedirect>
);
